import I18n from '@src/i18n';
import { Col, Icon, Input, InputNumber, Row, Button } from 'antd';
import React from 'react';
import styled from 'styled-components';

interface ISelectComponentPropsType {
  minMultiple?: number;
  maxMultiple?: number;
  options?: string;
  onChange: Function;
  isAPI?: boolean;
  key?: any;
}

interface ISelectTaskComponentStateType {
  options: any;
  isCollapsed: boolean;
  valid: boolean;
};
export default class SelectComponentProcess extends React.Component<ISelectComponentPropsType, ISelectTaskComponentStateType> {
  constructor(props: ISelectComponentPropsType) {
    super(props);
    this.state = {
      options: this.props.options || [{ value: undefined, weight: undefined }],
      isCollapsed: false,
      valid :true
    };

    this.handleCollapse = this.handleCollapse.bind(this)
  }

  componentWillMount = async () => {
    if (this.state.options[this.state.options.length - 1].value !== undefined) {
      this.setState({
        options: this.state.options.concat([{ value: undefined, weight: undefined }]),
      });
    }
  }

  componentWillReceiveProps = async (nexprops: any) => {
    if (this.props.options !== nexprops.options) {
      await this.setState({ options: nexprops.options })
      if (this.state.options[this.state.options.length - 1].value !== undefined) {
        this.setState({
          options: this.state.options.concat([{ value: undefined, weight: undefined }]),
        });
      }
    }
  }
  componentDidUpdate(prevProps : any, prevState : any){
    if (JSON.stringify(prevState.options) !== JSON.stringify(this.state.options))
    this.setState({valid: this.handleValidate()})
  }
  handleInputItemChange = (idx: any) => async (evt: any) => {

    const newSelectList = this.state.options.map((selectListItems: any, sidx: any) => {
      if (idx !== sidx) return selectListItems;
      return { ...selectListItems, value: evt.target.value };
    });
    await this.setState({ options: newSelectList });
    await this.handleAddNewSelectList(this.state.options, idx)
    const filterOptions = this.state.options.filter((e: any) => e.value !== undefined)
    if (this.state.options[idx].value === '') {
      await this.setState({ options: filterOptions })
    }

    await this.onSubmiSelectComponent()
  }
  handleInputScoreChange = (idx: any) => async (evt: any) => {
    const newSelectListScore = await this.state.options.map((selectListScore: any, sidx: any) => {
      if (idx !== sidx) return selectListScore;
      return { ...selectListScore, weight: evt };
    });
    this.setState({ options: newSelectListScore }, () => this.onSubmiSelectComponent());
  }
  handleAddNewSelectList = async (options: any, idx: number) => {
    if ((options[idx].value.length > 0 && options[idx].value.length < 2) && options[idx + 1] === undefined) {
      this.setState({
        options: this.state.options.concat([{ value: undefined, weight: undefined }]),
      });
    }
  }
  handleRemoveSelectGoTo = (index: number) => async () => {
    this.setState({
      options: this.state.options.filter((section: any, sindex: number) => index !== sindex),
    }, () => this.onSubmiSelectComponent());
  }

  onSubmiSelectComponent() {
    const newOptions = this.state.options.filter((e: any) => (e.value !== undefined || e.weight !== undefined))
    this.props.onChange(newOptions)
  }

  handleCollapse() {
    console.log(this.state.isCollapsed)
    this.setState({ isCollapsed: !this.state.isCollapsed })
  }
  handleValidate() {
    if (this.props.minMultiple && this.state.options.length < this.props.minMultiple || this.props.maxMultiple && this.state.options.length > this.props.maxMultiple)
      return false
    return true
  }
  render() {

    return (<>
      <CanCollapse key={this.props.key} className={["can-collapse", (this.state.isCollapsed ? "collapsed" : "opened")].join(' ')}>
        {this.state.options.map((list: any, idx: number) => (
          <div key={idx}>
            <Row>
              <Col span={10} >
                <Input
                  placeholder={I18n.l('label.components.writeHere')}
                  style={{ backgroundColor: 'white', width: '100%', marginRight: '1rem', border: '1px solid #C8C8C8' }}
                  value={list.value}
                  maxLength={150}
                  onChange={this.handleInputItemChange(idx)}
                />
                <div>
                  {(list.value === '' || this.state.options.length <= 1) &&
                    <div style={{ color: 'red', marginBottom: '10px', fontWeight: 'bold' }}>
                      <span >{I18n.l('label.selectValidation')}</span>
                    </div>
                  }

                </div>

              </Col>
              <Col span={10} >
                <InputNumber
                  placeholder={I18n.l('label.components.enterScore')}
                  style={{ width: '50%', border: '1px solid #C8C8C8', marginLeft: '10px' }}
                  value={list.weight}
                  onChange={this.handleInputScoreChange(idx)}
                />
                {(this.state.options.length > 1 && idx !== (this.state.options.length - 1)) &&
                  <span onPointerDown={this.handleRemoveSelectGoTo(idx)}>
                    <Icon
                      style={{ color: 'red', marginLeft: '5px', cursor: "pointer" }}
                      type="close"
                    />
                  </span>
                }

              </Col>
            </Row>
          </div>
        ))}
        {this.state.options.length > (this.props.maxMultiple + 1) &&
          <div style={{ color: 'red', marginBottom: '10px', fontWeight: 'bold' }}>
            <span >{I18n.l('label.limit')}</span>
          </div>
        }
        {this.state.options.length < (this.props.minMultiple + 1) &&
          <div style={{ color: 'red', marginBottom: '10px', fontWeight: 'bold' }}>
            <span >{I18n.l('list.minimum')}</span>
          </div>
        }
      </CanCollapse>
      <ButtonCollapse className="button-collapse" size="small" shape="circle" onClick={this.handleCollapse}>
        {this.state.isCollapsed && <Icon type="caret-down" />}
        {!this.state.isCollapsed && <Icon type="caret-up" />}
      </ButtonCollapse>
    </>);
  }
}

const CanCollapse = styled.div`
&.collapsed {
  height: 0;
  overflow: hidden;
}
`

const ButtonCollapse = styled(Button)`
position: absolute;
bottom: 0;
`
